<div class="flex items-center justify-center" *ngIf="user">
    <!-- Button -->
    <button mat-icon-button [matMenuTriggerFor]="userActions" [matTooltip]="user?.name">
        <span
            class="relative flex items-center justify-center w-8 h-8 rounded-full bg-primary-100 dark:bg-primary-900/40 text-primary-700 dark:text-primary-200 text-base font-bold uppercase leading-none p-0"
        >
            {{ initials }}
        </span>
    </button>

    <mat-menu [xPosition]="'before'" #userActions="matMenu">
        <div class="user-menu-identity px-4 py-3 min-w-0 max-w-[280px]">
            <div class="flex flex-col items-start leading-tight gap-1.5 min-w-0">
                <span class="text-md font-semibold text-gray-900 dark:text-gray-100 truncate w-full" dir="auto">{{
                    user.name
                }}</span>
                <span dir="ltr" class="text-sm text-secondary truncate w-full">{{
                    user.email
                }}</span>
                <span
                    *ngIf="permissionGroupLabel"
                    class="inline-flex max-w-full items-center rounded-full px-2 py-0.5 text-[9px] font-medium leading-none bg-primary-100 text-primary-800 dark:bg-primary-900/50 dark:text-primary-100 truncate"
                >
                    {{ permissionGroupLabel }}
                </span>
            </div>
        </div>
        <mat-divider class="my-0"></mat-divider>
        <button mat-menu-item (click)="editUser()">
            <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
            <span autoTranslate>Perfil</span>
        </button>
        <button *ngIf="user.is_admin" mat-menu-item [routerLink]="['/module-entry']">
            <mat-icon [svgIcon]="'heroicons_outline:squares-2x2'"></mat-icon>
            <span autoTranslate>Escolher módulo</span>
        </button>
        <button *ngIf="showAdminPanelMenu && !isAdminRoute" mat-menu-item [routerLink]="['/admin']">
            <mat-icon [svgIcon]="'heroicons_outline:shield-check'"></mat-icon>
            <span autoTranslate>Painel Admin</span>
        </button>
        <button *ngIf="showAllocationEngineMenu" mat-menu-item [routerLink]="['/allocation-engine']">
            <mat-icon [svgIcon]="'heroicons_outline:rectangle-group'"></mat-icon>
            <span autoTranslate>Motor de Alocação</span>
        </button>
        <button *ngIf="user.is_admin && !isRequesterPortalActive" mat-menu-item (click)="openRequesterPortal()">
            <mat-icon [svgIcon]="'heroicons_outline:user-group'"></mat-icon>
            <span autoTranslate>Solicitante</span>
        </button>
        <button *ngIf="(user.is_admin && isAdminRoute) || isAllocationEngineRoute" mat-menu-item [routerLink]="['/home']">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
            <span autoTranslate>Voltar ao App</span>
        </button>
        <button *ngIf="user.is_admin && isRequesterPortalActive && !isAdminRoute && !isAllocationEngineRoute" mat-menu-item (click)="returnToMainApp()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
            <span autoTranslate>Voltar ao App</span>
        </button>
        <!--
        <button *ngIf="isHome && user.function?.is_admin" mat-menu-item [routerLink]="['/home/funcoes']">
            <mat-icon [svgIcon]="'heroicons_outline:key'"></mat-icon>
            <span autoTranslate>Funções</span>
        </button>
        <button *ngIf="isHome && user.function?.is_admin" mat-menu-item [routerLink]="['/home/usuarios/user']">
            <mat-icon [svgIcon]="'heroicons_outline:users'"></mat-icon>
            <span autoTranslate>Usuários</span>
        </button>
        <button *ngIf="isHome && user.function?.is_admin" mat-menu-item [routerLink]="['/home/banners']">
            <mat-icon [svgIcon]="'heroicons_outline:photo'"></mat-icon>
            <span autoTranslate>Banner</span>
        </button>
        <button *ngIf="isHome && user.function?.is_admin" mat-menu-item [routerLink]="['/home/holidays']">
            <mat-icon [svgIcon]="'heroicons_outline:globe-americas'"></mat-icon>
            <span autoTranslate>Feriados</span>
        </button>

        <button mat-menu-item [routerLink]="['/change-password']">
            <mat-icon [svgIcon]="'heroicons_outline:shield-check'"></mat-icon>
            <span autoTranslate>Alterar senha</span>
        </button> -->
        <!-- <button mat-menu-item (click)="toggleSchema()">
            <mat-icon [svgIcon]="'heroicons_outline:adjustments-horizontal'"></mat-icon>
            <span>{{ ('Alternar Esquema (' + (schema === 'light' ? 'Claro' : schema === 'dark' ? 'Escuro' : 'Automático') + ')') | autoTranslate }}</span>
        </button> -->
        <!-- <div mat-menu-item class="uppercase font-semibold flex text-gray-700 dark:text-secondary-500 ml-4">
            <button mat-icon-button [matTooltip]="(isDark ? 'Claro' : 'Escuro') | autoTranslate" (click)="setTheme(isDark ? 'light' : 'dark')">
                <mat-icon [svgIcon]="isDark ? 'heroicons_outline:sun' : 'heroicons_outline:moon'"></mat-icon>
            </button>
            <button mat-icon-button [matTooltip]="(isAuto ? 'Auto Ligado' : 'Auto Desligado') | autoTranslate" (click)="setThemeAuto()">
                <mat-icon [svgIcon]="isAuto ? 'heroicons_solid:bolt' : 'heroicons_outline:bolt'"></mat-icon>
            </button>
        </div> -->
        <button mat-menu-item (click)="signOut()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
            <span autoTranslate>Sair</span>
        </button>
    </mat-menu>
</div>
